import { render, staticRenderFns } from "./PromotionsLibraryActions.vue?vue&type=template&id=13589a3f&"
import script from "./PromotionsLibraryActions.vue?vue&type=script&lang=js&"
export * from "./PromotionsLibraryActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports